<template>
  <div>
    <div v-if="isSuccess" class="dropbox success">
      <img :src="image" width="104" class="">
      <div class="info">
        <p>Formatos permitidos: JPEG, PNG, GIF.</p>
        <p><a href="javascript:void(0)" @click="reset()">Enviar novo logo</a></p>
      </div>
    </div>

    <div v-if="isFailed">
      <div class="header">Falha no envio da imagem!</div>
      <p><a href="javascript:void(0)" @click="reset()">Tente novamente</a></p>
      <p>{{ uploadError }}</p>
    </div>

    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
      <div class="dropbox">
        <input
          type="file"
          :name="uploadFieldName"
          @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
          accept="image/*"
          class="input-file">

        <p v-if="isInitial">Arraste ou clique para procurar</p>
      </div>
    </form>
  </div>
</template>

<script>
const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 'Upload',
  props: ['posLogo'],
  data () {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'file'
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  methods: {
    reset () {
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save (formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING

      const url = process.env.VUE_APP_URL_APP + '/b/upload' + (this.posLogo ? '?poslogo=true' : '')
      const baseUrl = process.env.VUE_APP_URL_WEB

      const options = {
        emulateJSON: true
      }

      this.$http.post(url, formData, options).then(response => {
        this.uploadedFiles = [].concat({
          url: baseUrl + response.body.path
        })
        this.$emit('uploaded', this.uploadedFiles[0].url)
        this.image = this.uploadedFiles[0].url
        this.currentStatus = STATUS_SUCCESS
      }, err => {
        this.uploadError = err.body.error_description
        this.currentStatus = STATUS_FAILED
      })
    },
    filesChange (fieldName, fileList) {
      // handle file changes
      const formData = new FormData()

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })

      // save it
      this.save(formData)
    }
  },
  mounted () {
    this.reset()
  }
}
</script>
